import tmdb from './client';

const TodayTrend = (config = {}) =>
  tmdb.get('/trending/all/day', {
    ...config,
    params: { language: 'en-US', ...(config.params || {}) },
  });

export default TodayTrend;
